/* Bag drawer extras (SimGym 2026-10-01), added after rb-app.js draws the bag:
   - each line shows its price before savings struck through and "You save $X" when it is cheaper than that:
     the marked down size's compare at price (read from /products/<handle>.js, shopper's currency) or the price before
     the sale's automatic discount (cart.js original_line_price),
   - a free shipping line above the subtotal: "You've got free shipping" at the threshold, otherwise "Add $X ...".
   The cart page does the same in Liquid (sections/rb-main-cart.liquid). */
(function () {
  const body = document.getElementById('bagBody'), foot = document.getElementById('bagFoot');
  const cfgEl = document.getElementById('rbCartPlus');
  if (!body || !foot || !cfgEl) return;
  const C = JSON.parse(cfgEl.textContent);
  const R = (window.RBCFG && window.RBCFG.routes) || {};
  const base = (R.root || '/').replace(/\/?$/, '/');
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const money = (c, cur) => (window.RBUI ? window.RBUI.money(c, cur) : '$' + (c / 100).toFixed(2));
  const prod = new Map();
  const getProd = (h) => {
    if (!prod.has(h)) prod.set(h, fetch(`${base}products/${encodeURIComponent(h)}.js`, { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null));
    return prod.get(h);
  };
  let busy = false, again = false;

  async function paint() {
    if (busy) { again = true; return; }
    if (!body.querySelector('.line-item')) return;
    busy = true;
    try {
      const cart = await fetch(`${base}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const items = new Map((cart.items || []).map((i) => [i.key, i]));
      // free shipping line
      const tot = [...foot.querySelectorAll('.tot')].pop();
      if (tot) {
        let line = foot.querySelector('.rb-ship');
        if (!line) { line = document.createElement('p'); line.className = 'rb-ship'; tot.before(line); }
        const free = cart.total_price >= C.free_at;
        const txt = free ? C.free : String(C.more).replace('{{ amount }}', money(C.free_at - cart.total_price, cart.currency));
        line.classList.toggle('is-free', free);
        if (line.textContent !== txt) line.textContent = txt;
      }
      // per line savings
      for (const li of body.querySelectorAll('.line-item')) {
        const k = li.querySelector('[data-k]'); const it = k && items.get(k.dataset.k); if (!it) continue;
        let was = it.original_line_price;
        const p = await getProd(it.handle);
        const v = p && (p.variants || []).find((x) => x.id === it.variant_id);
        if (v && v.compare_at_price && v.compare_at_price * it.quantity > was) was = v.compare_at_price * it.quantity;
        const save = was - it.final_line_price;
        // "You save" only for a marked down rug (its compare at price): sale and order discounts are already listed
        // under the rug, so repeating them here would count them twice
        const mark = was - it.original_line_price;
        const r = li.querySelector('.r'); if (!r) continue;
        let s = r.querySelector('s');
        let sv = r.querySelector('.rb-save');
        if (save > 0) {
          if (!s) { s = document.createElement('s'); s.className = 'num'; s.style.cssText = 'display:block;color:var(--ink-3);font-size:.85em'; r.prepend(s); }
          const st = money(was, cart.currency); if (s.textContent !== st) s.textContent = st;
          if (mark > 0) {
            if (!sv) { sv = document.createElement('span'); sv.className = 'rb-save'; const rm = r.querySelector('.rm'); if (rm) rm.before(sv); else r.appendChild(sv); }
            const tx = String(C.save).replace('{{ amount }}', money(mark, cart.currency)); if (sv.textContent !== tx) sv.textContent = tx;
          } else if (sv) sv.remove();
        } else if (sv) sv.remove();
      }
    } catch (e) {} finally { busy = false; if (again) { again = false; paint(); } }
  }

  let q = 0;
  const soon = () => { clearTimeout(q); q = setTimeout(paint, 30); };
  // rb-app.js replaces the drawer's lines and foot on every change; repaint after each redraw (our own edits are
  // inside existing nodes or a single added line, so they do not loop)
  new MutationObserver((recs) => { if (recs.some((r) => [...r.addedNodes].some((n) => n.nodeType === 1 && !n.classList.contains('rb-ship') && !n.classList.contains('rb-save') && n.tagName !== 'S'))) soon(); })
    .observe(body, { childList: true });
  new MutationObserver((recs) => { if (recs.some((r) => [...r.addedNodes].some((n) => n.nodeType === 1 && !n.classList.contains('rb-ship')))) soon(); })
    .observe(foot, { childList: true });
})();
